// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Qh6","name":"styles_name__1QRpB","phone":"styles_phone__1Jew6"};